module.exports = __webpack_public_path__ + "img/b.ef875b65.png";